import { useEffect, useState } from "react";

/** Seconds since `iso`, ticking every second while `active`. */
export function useElapsedSeconds(iso: string | undefined, active: boolean): number | null {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [active]);
  if (!iso || !active) return null;
  return Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
}
